angular.module('rjmNg.services').factory('currencyService', [
  "$http"
  "$rootScope"
  "$url"
  (
    $http
    $rootScope
    $url
  ) ->
    currencyService = {}

    currencyService.fetch = () ->
      $http.get($url("/currency"))

    currencyService
  ]
)
